module.exports = __webpack_public_path__ + "assets/c6f6a08fd1d34bdc2a82ddaba068ab14.svg";